module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_05.03cb7fc4.jpg";